import { RouterProvider } from "react-router-dom";

import { enableMapSet } from "immer";
import { createRoot } from "react-dom/client";

import { router } from "./app/core/routes/router";
import "./styles/index.css";

const container = document.getElementById("app");
if (!container) {
    throw new Error("Failed to find root #app element.");
}

container.dataset["version"] = import.meta.env.VITE_VERSION;
enableMapSet();

const root = createRoot(container);
root.render(<RouterProvider router={router} />);
